<template>
  <div>
    <div class="col-12 d-flex" style="padding-top: 12px">
      <div class="form-group has-search">
        <span
          class="fa fa-search form-control-feedback"
          style="margin-top: 0"
        ></span>
        <input
          type="text"
          class="form-control upcoming-tasks-search"
          v-model="searchQuery"
          aria-controls="datatables"
          style="width: 203px"
          placeholder="Search Records"
        />
      </div>
      <div>
        <button
          class="newTask filterBtn ml-2"
          :style="
            portfolioData.length <= 0
              ? 'cursor:not-allowed'
              : 'border:0px;height:100%'
          "
          @click="showFilter = !showFilter"
          :disabled="portfolioData.length <= 0"
        >
          <img src="static/img/filter.svg" class="mr-1" />
          Filters
        </button>
        <PortfolioFilters
          v-if="showFilter"
          v-model="filterValues"
        ></PortfolioFilters>
      </div>
      <!-- <b-dropdown id="dropdown-1" text="Add Company" class="add-company-dropdown" no-caret>
        <template v-slot:button-content>
          <i class="fa fa-plus" aria-hidden="true"></i> Add Company
        </template>
        <b-dropdown-item @click="handleCreateCompany">Add Company</b-dropdown-item>
        <b-dropdown-item
          :href="`#/${$route.params.account_id}/${$route.params.workspace_id}/portfolio/import`"
        >Upload Excel</b-dropdown-item>
      </b-dropdown>-->
    </div>
    <a
      class="hidden"
      ref="hiddenDownloadAnchor"
      href="https://www.dropbox.com/s/i0y6cmzot51vzyn/ExampleXLS_0.2.xlsx?dl=1"
      >Download Sample</a
    >
    <div class="col-sm-12 mt-2">
      <div id="theMainTableBoxInvestments">
        <div id="theMainTableFixerInvestments">
          <div
            class="tabulator direct-invst-table"
            v-if="refresh"
            ref="table"
            style="width: 100%; height: 100%"
          ></div>
        </div>
      </div>
    </div>
    <!-- <button @click="download" class="btn btn-info btn-fill btn-wd downloadCsv">
      <i class="fa fa-download" aria-hidden="true"></i>
      Download as CSV
    </button>-->
    <dialogconfirmcompany
      v-model="dialogDataConfirmCompany"
    ></dialogconfirmcompany>
    <el-dialog
      left
      title="Share Company"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showClose="true"
      width="500px"
      style="margin: 0 auto"
      :visible.sync="modalShow"
      @close="
        tags = [];
        sharingNote = '';
        refreshForm = false;
      "
      class="team-modal col-lg-12 col-sm-12 col-12 col-md-12"
    >
      <div>
        <div>Email</div>
        <b-form-group :state="state" label-for="tags-validation">
          <b-form-tags
            input-id="tags-validation"
            invalid-tag-text="Invalid email(s)"
            duplicate-tag-text="Duplicate email(s)"
            :input-attrs="{ 'aria-describedby': 'tags-validation-help' }"
            v-model="tags"
            :state="state"
            placeholder="Enter Emails separated by comma"
            tag-variant="primary"
            v-if="refreshForm"
            tag-pills
            :tag-validator="tagValidator"
            add-on-change
            separator=","
            @tag-state="onTagState"
          ></b-form-tags>

          <!-- The following slots are for b-form-group
          <template v-slot:invalid-feedback>You must provide at least 1 email and no more than 6</template>-->
        </b-form-group>
        <div>Notes</div>
        <textarea
          placeholder="Notes"
          rows="5"
          cols="50"
          class="form-control"
          spellcheck="false"
          v-model="sharingNote"
        ></textarea>
        <div class="edit-company-action-button-row py-3" style="margin: 0px">
          <button
            type="button"
            @click="modalShow = !modalShow"
            class="todo-form-cancel-button btn-outline-secondary"
          >
            Cancel
          </button>
          <button
            type="submit"
            @click.prevent="sendEmail"
            :disabled="emailCheck || submit"
            class="todo-form-submit-button btn btn-primary"
            style="height: 35px"
          >
            Send
            <b-spinner
              v-if="submit"
              style="float: right"
              small
              label="Loading..."
            ></b-spinner>
          </button>
        </div>
      </div>
    </el-dialog>
    <addCompany
      v-model="addCompanyProps"
      v-if="showAddCompanyModal"
    ></addCompany>
    <editCompany
      v-model="editCompanyModalProps"
      v-if="showEditModalPopup"
    ></editCompany>
    <DialogAddInvestmentForm
      :organization="investmentCompany.organization"
      :contactEmail="contactEmailString"
      :currentCompany="investmentCompany"
      :investments="[]"
      context="company-profile"
      v-model="dialogMyInvestmentData"
    ></DialogAddInvestmentForm>
    <custom-menu></custom-menu>
    <el-dialog
      left
      title="Add Company"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showClose="true"
      @close="handleAddCompanyCancel()"
      :visible.sync="addCompanyShow"
      style="margin: 0 auto"
      class="addCompanyModal col-lg-12 col-sm-12 col-12 col-md-12"
    >
      <div class="row">
        <div class="col-12">
          <vue-bootstrap-typeahead
            :data="companiesList"
            v-model="companyName"
            ref="refCompanyName"
            class="diligenceAutoCompleteClass"
            :serializer="checkCompany"
            :minMatchingChars="minMatchingChars"
            placeholder="Enter Company Name"
            @hit="onAfterCompanySelection"
          >
            <template slot="suggestion" slot-scope="{ data }">
              <div
                :class="data && data.duplicate == 'found' ? 'duplicate' : ''"
              >
                <div
                  class="dd-icon-wrapper"
                  v-if="data.properties && data.properties.profile_image_url"
                >
                  <img
                    class="dd-icon"
                    height="30"
                    width="30"
                    :src="getImageUrl(data.properties.profile_image_url)"
                  />
                </div>
                {{ data.properties.name }}
                <span class="gray">{{
                  data.properties.short_description
                }}</span>
                <span v-if="data && data.duplicate == 'found'" class="exists"
                  >already exists</span
                >
              </div>
            </template>
          </vue-bootstrap-typeahead>
        </div>
      </div>
      <div slot="footer" class="dialog-footer" style>
        <div
          style="
            border: 0.8px solid #ededed;
            opacity: 1;
            margin-top: 18px;
            display: none;
          "
        ></div>
        <div
          class="col-xl edit-company-action-button-row"
          style="padding: 0px; margin-top: 30px"
        >
          <button
            type="button"
            class="todo-form-cancel-button btn-outline-secondary"
            @click="handleAddCompanyCancel"
          >
            Cancel
          </button>
          <button
            type="button"
            class="todo-form-submit-button btn btn-primary"
            @click.prevent="companySave()"
            :disabled="addCompanySpinner || !selected"
          >
            Save
            <b-spinner
              v-if="addCompanySpinner"
              style="float: right"
              small
              label="Loading..."
            ></b-spinner>
          </button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      center
      title="Really Delete?"
      :context="modalContext"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showClose="false"
      width="400px"
      :visible.sync="showDeleteModal"
    >
      <confirm-card
        :context="modalContext"
        @confirm-card-close="closeModal"
        ref="confirmDeleteCard"
      ></confirm-card>
    </el-dialog>
  </div>
</template>
<script>
import moment from "moment";
import util from "util";
import { Select, Option, Dialog } from "element-ui";
import NotificationSample from "../Components/NotificationSample";
import Tabulator from "tabulator-tables";
import AddCompany from "../Dialogs/AddCompany";
import EditCompanyDialog from "../Dialogs/EditCompany";
import _ from "lodash";
import {
  stageSelect,
  statusSelect,
  directSelect,
  numberSorter,
} from "./investments";
import { mapGetters } from "vuex";
import { vals, formatNumberWithComma, cbAdapter } from "../../../util";
import DialogConfirmCompany from "../Dialogs/DialogConfirmCompany";
import api from "../../../axios_api";
import CustomMenu from "../Components/CustomMenu.vue";
import DialogAddInvestmentForm from "../Dialogs/DialogAddInvestmentForm";
import PortfolioFilters from "./PortfolioFilters";
import config from "../../../../config/settings";
import VueBootstrapTypeahead from "vue-bootstrap-typeahead";
import ConfirmCard from "../../../components/Cards/ConfirmCard";
const DATA_STATUS_CONFIRMED = "Confirmed";
const DATA_STATUS_UNCONFIRMED = "Unconfirmed";
const DATA_STATUS_UPDATING = "Retrieving";
const CRUNCHBASE_BASE_URL = "https://api.crunchbase.com/v3.1/";
const CRUNCHBASE_USER_KEY = "f488b788b922f095807326b936073e45";

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Dialog.name]: Dialog,
    [DialogConfirmCompany.name]: DialogConfirmCompany,
    [EditCompanyDialog.name]: EditCompanyDialog,
    [AddCompany.name]: AddCompany,
    [CustomMenu.name]: CustomMenu,
    PortfolioFilters,
    DialogAddInvestmentForm,
    VueBootstrapTypeahead,
    ConfirmCard,
  },
  computed: {
    ...mapGetters("portfolio", [
      "portfolioData",
      "hasData",
      "portfolioAll",
      "dataLoaded",
    ]),
    ...mapGetters("user", ["currency", "firstName", "lastName"]),
    ...mapGetters("user", ["user"]),
    ...mapGetters("role", ["getCurrentWorkspaceRolePermissions"]),
    sortedSectors() {
      let sectorList = vals.sectorList;
      sectorList.sort((a, b) => a.localeCompare(b));
      return sectorList;
    },
    emailCheck() {
      if (this.tags.length > 0 && this.invalidTags.length == 0) return false;
      else return true;
    },
    state() {
      return this.dirty ? this.tags.length > 0 && this.tags.length < 10 : null;
    },
    tableData() {
      this.getMinMaxCostValue();
      this.getMinMaxOwnershipValue();
      this.getMinMaxMultipleValue();
      return this.getTableData();
    },
    pagedData() {
      return this.tableData.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      this.pagination.total = this.tableData.length;
      return this.tableData.length;
    },
    tableColumns() {
      const self = this;
      let that = this;
      self.portfolioAllRows = self.portfolioData;
      function isEditable(cell) {
        return (
          cell.getData()["data_status"] == DATA_STATUS_CONFIRMED &&
          self.isInlineEditable
        );
      }

      var costValidator = function (cell, value, parameters) {
        //cell - the cell component for the edited cell
        //value - the new input value of the cell
        //parameters - the parameters passed in with the validator
        if (cell.getData().cost > value) {
          //self.$toaster.error("cost cannot be reduced");
          return false;
        }

        return true; //don't allow values divisible by devisor ;
      };

      var ownershipValidator = function (cell, value, parameters) {
        //cell - the cell component for the edited cell
        //value - the new input value of the cell
        //parameters - the parameters passed in with the validator
        if (value > 100) {
          return false;
        }
        if (cell.getData().ownership < value) {
          //self.$toaster.error("cost cannot be reduced");
          if (value % 1 != 0) {
            let data = value.toString().split(".");
            if (data[data.length - 1] > 9) {
              return false;
            }
          }
          return true;
        }
        if (cell.getData().ownership > value) {
          return false;
        }
        return true;
      };

      let dateEditor = function (
        cell,
        onRendered,
        success,
        cancel,
        editorParams
      ) {
        //cell - the cell component for the editable cell
        //onRendered - function to call when the editor has been rendered
        //success - function to call to pass the successfuly updated value to Tabulator
        //cancel - function to call to abort the edit and return to a normal cell
        //editorParams - params object passed into the editorParams column definition property

        //create and style editor
        var editor = document.createElement("input");

        editor.setAttribute("type", "date");

        //create and style input
        editor.style.padding = "3px";
        editor.style.width = "100%";
        editor.style.boxSizing = "border-box";

        //Set value of editor to the current value of the cell

        editor.setAttribute(
          "value",
          cell.getValue() && cell.getValue() != "-"
            ? moment.utc(cell.getValue()).format("YYYY-MM-DD")
            : ""
        );
        // .format("YYYY-MM-DD");

        //set focus on the select box when the editor is selected (timeout allows for editor to be added to DOM)
        onRendered(function () {
          editor.focus();
          editor.style.css = "100%";
        });

        //when the value has been set, trigger the cell to update
        function successFunc() {
          if (editor.value) {
            editor.value &&
            editor.value != "-" &&
            editor.value != "Invalid date"
              ? success(moment.utc(editor.value).format("MM/DD/YYYY"))
              : success("");
            // .format("MM/DD/YYYY"));
          } else {
            if (
              cell.getValue() &&
              cell.getValue() != "Invalid date" &&
              cell.getValue() != "-"
            ) {
              success(moment.utc(cell.getValue()).format("MM/DD/YYYY"));
              // .format("MM/DD/YYYY"));
            } else {
              if (
                cell.getValue() &&
                cell.getValue() != "missing date" &&
                cell.getValue() != "-"
              ) {
                success(moment.utc(cell.getValue()).format("MM/DD/YYYY"));
              }
              if (cell.getValue() && cell.getValue() == "-") {
                cancel();
              }
            }
          }
        }

        editor.addEventListener("change", successFunc);
        editor.addEventListener("blur", successFunc);

        //return the editor element
        return editor;
      };
      let deleteIcon = function (cell, formatterParams) {
        if (
          cell.getData()["isDeleting"] &&
          cell.getData()["isDeleting"] == true
        )
          return '<i class="nc-icon nc-refresh-02 spinner"></i>';
        else
          return "<a class=''><i class='far fa-trash-alt' style='color: #7D7D7D;'></i></a>";
      };
      let deleteEditor = function (
        cell,
        onRendered,
        success,
        cancel,
        editorParams
      ) {
        cell.getData().isDeleting = true;
        let data = cell.getData();
        let ucid = data.ucid;
        let _id = data._id;

        // assume successful delete, next people...
        api
          .delete(
            `${self.$route.params.account_id}/${self.$route.params.workspace_id}/company/investment/${ucid}`
          )
          .then((data) => {
            console.log(data);
          })
          .catch((err) => {
            console.log(err);
          });
        return self.$store
          .dispatch("people/removeCompany", {
            ucid: ucid,
          })
          .then((res) => {
            // delete all attachments
            return self.$store.dispatch("file/removeCompany", {
              ucid: ucid,
            });
          })
          .then((res) => {
            // delete all attachments
            return self.$store.dispatch("attachment/removeCompany", {
              ucid: ucid,
            });
          })
          .then((res) => {
            // delete all attachments
            return self.$store.dispatch("investment/removeCompany", {
              ucid: ucid,
            });
          })
          .then((res) => {
            return self.$store.dispatch("portfolio/apiDeletePortfolio", {
              ucid: ucid,
              _id: _id,
            });
          })
          .then((res) => {
            // assume successful delete, finally company...
            return self.$store.dispatch("company/apiFetchCompany");
          })
          .then((res) => {
            return self.$store.dispatch("portfolio/_apiFetchPortfolio");
          })
          .then((res) => {
            // done, company should be erased, go back
            cell.getRow().delete();
          })
          .catch((err) => {
            console.error(`Error during delete process, aborting... ${err}`);
            cell.getData().isDeleting = false;
            cell.getTable().redraw();
            // go back to investments
          });
      };
      let mapEditor = function (
        cell,
        onRendered,
        success,
        cancel,
        editorParams
      ) {
        try {
          let form = document.createElement("form");
          form.setAttribute("id", "form");
          form.setAttribute("autocomplete", "off");

          let editor = document.createElement("input");
          editor.setAttribute("id", "autocomplete_search");
          editor.setAttribute("list", "json-datalist");
          editor.style.padding = "3px";
          editor.style.width = "100%";
          editor.style.boxSizing = "border-box";

          form.appendChild(editor);

          if (document.getElementById("json-datalist"))
            document.getElementById("json-datalist").remove();

          let dataList = document.createElement("datalist");
          dataList.setAttribute("id", "json-datalist");
          form.appendChild(dataList);

          editor.addEventListener("input", () => {
            let autocomplete_search = document.getElementById(
              "autocomplete_search"
            );

            let displaySuggestions = function (predictions, status) {
              if (status != google.maps.places.PlacesServiceStatus.OK) {
                console.log(status);
              }
              if (predictions)
                predictions.map((item) => {
                  var option = document.createElement("option");
                  option.value = item.description;
                  dataList.appendChild(option);
                });
            };
            let service = new google.maps.places.AutocompleteService();
            service.getQueryPredictions(
              { input: editor.value },
              displaySuggestions
            );
          });
          editor.addEventListener("change", () => {
            if (editor.value.length) success(editor.value);
          });
          return form;
        } catch (err) {
          console.log(err);
        }
      };
      let handleMenu = function (_cell, a, b) {
        _cell.getElement().addEventListener("click", () => {
          let data = _cell.getData();
          let ctxMenuData = [];
          if (data.permalink) {
            ctxMenuData = [
              {
                title: "Share Company",
                handler: () => {
                  self.tags = [];
                  self.submit = false;
                  self.modalShow = true;
                  self.refreshForm = true;
                  self.downloadCompany = _cell.getData();
                },
              },
              // {
              //   type: "divider"
              // },
              {
                title: "Download",
                handler: () => {
                  self.downloadPdf(_cell.getData(), "Download as Pdf");
                },
              },
              {
                title: "Delete",
                handler: () => {
                  self.data = _cell.getData();
                  self.showDeleteModal = true;
                },
              },
            ];
          } else {
            ctxMenuData = [
              {
                title: "Download",
                handler: () => {
                  self.downloadPdf(_cell.getData(), "Download as Pdf");
                },
              },
              {
                title: "Delete",
                handler: () => {
                  self.data = _cell.getData();
                  self.showDeleteModal = true;
                },
              },
            ];
          }
          if (!self.showDeleteCompany) {
            ctxMenuData.pop();
          }
          self.$root.$emit("contextmenu", { event, ctxMenuData });
        });

        return `
        <i class="fas fa-ellipsis-v" style="color: #7D7D7D;"></i>
        `;
      };
      return [
        {
          title: "Company Name",
          field: "name",
          sorter: "string",
          download: true,
          visible: false,
        },
        {
          title: "Company",
          field: "nameLogoString",
          sorter: function (a, b, aRow, bRow, column, dir, sorterParams) {
            let first = aRow.getData().name || "";
            let second = bRow.getData().name || "";
            return first.localeCompare(second);
          },
          responsive: 0,
          resizable: false,
          width: "260",
          download: false,
          formatter: "html",
          tooltip: function (cell) {
            let tootipData = `${cell._cell.row.data.name} - ${cell._cell.row.data.status}`;
            return tootipData;
          },
          cellClick: function (e, cell) {
            if (
              [DATA_STATUS_CONFIRMED, DATA_STATUS_UPDATING].indexOf(
                cell.getData()["data_status"]
              ) == -1
            ) {
              return;
            }
            // set the 'current company' and go to the company profile
            let name = cell.getData().name;
            // get the ucid
            let ucid = _.reduce(
              self.portfolioData,
              (memo, data) => {
                if (data.name == name) return data.ucid;
                return memo;
              },
              -1
            );
            // save our current company and go to the profile page
            self.$store.commit("temp/currentCompany", ucid);
            self.$router.push(
              `/${self.$route.params.account_id}/${self.$route.params.workspace_id}/companyProfile/${ucid}`
            );
          },
        },
        {
          title: "data_status",
          field: "data_status",
          sorter: "string",
          editor: "select",
          download: false,
          visible: false,
        },
        {
          title: "Status",
          field: "status",
          sorter: "string",
          editor: "select",
          download: true,
          visible: false,
          editable: isEditable,
          editorParams: { values: vals.STATUS_DEFINES, defaultValue: "Active" },
        },
        {
          title: "Ownership (%)",
          field: "ownership",
          sorter: "number",
          editor: "number",
          resizable: false,
          download: true,
          responsive: 0,
          //width: "130",
          minWidth: "126",
          editable: false,
          validator: [{ type: ownershipValidator, parameters: {} }],
          formatter: function (cell, params) {
            if (_.isNumber(cell.getValue()) && cell.getValue() !== 0)
              return cell.getValue() + "%";
            else if (_.isNil(cell.getValue()) || cell.getValue() == 0)
              return "N/A";
            return cell.getValue();
          },
        },
        {
          title: "Cost ($)",
          field: "cost",
          sorter: numberSorter,
          formatter: "money",
          minWidth: "88",
          resizable: false,
          formatterParams: this.currency.format,
          editor: "number",
          responsive: 0,
          download: true,
          editable: false,
          validator: [{ type: costValidator, parameters: {} }],
        },

        {
          title: "Value ($)",
          field: "value",
          sorter: numberSorter,
          resizable: false,
          formatter: "money",
          minWidth: "98",
          formatterParams: this.currency.format,
          editor: "number",
          responsive: 0,
          download: true,
          editable: false,
        },
        {
          title: "Gain/Loss ($)",
          field: "gain_loss",
          sorter: numberSorter,
          resizable: false,
          minWidth: "114",
          formatter: function (cell, params) {
            let data = cell.getData();
            let gain_loss =
              data.value >= 0 && data.cost >= 0 ? data.value - data.cost : 0;
            return gain_loss < 0
              ? `-$${formatNumberWithComma(Math.abs(gain_loss))}`
              : `$${formatNumberWithComma(gain_loss)}`;
          },
          responsive: 0,
          download: true,
          //formatterParams: this.currency.format
        },
        {
          title: "Initial Investment",
          field: "initial_investment",
          minWidth: "146",
          sorter: function (a, b, aRow, bRow, column, dir, sorterParams) {
            let data;
            if (a != "-" && b != "-")
              data = new Date(a).getTime() - new Date(b).getTime();
            else if (a != "-") data = new Date(a).getTime();
            else data = -new Date(b).getTime();
            return data;
          },
          // formatter: "datetime",
          resizable: false,
          editor: dateEditor,
          download: true,
          responsive: 0,
          editable: isEditable,
          // formatterParams: {
          //   //inputFormat: "MM/DD/YYYY",
          //   outputFormat: "MM/DD/YYYY",
          //   invalidPlaceholder: "-"
          // },
          // formatter: function(cell, formatterParams) {
          //   let data = cell.getData();
          //   if (
          //     data.initial_investment &&
          //     data.initial_investment != "-" &&
          //     data.initial_investment != "missing date"
          //   ) {
          //     return moment.utc(data.initial_investment).format("MM/DD/YYYY");
          //   } else {
          //     return "-";
          //   }
          // },
          cellEditing: function (cell) {
            //cell - cell component
            self.isEditing = true;
          },
          cellEdited: function (cell) {
            //cell - cell component
            let data = cell.getData();
            let serverData = {};
            serverData.initial_investment = data.initial_investment;
            serverData._id = data._id;
            serverData.__v = data.__v;
            let path = "company/apiPatchCompanyInst";
            self.$store.dispatch(path, serverData).then((response) => {
              if (response.success.length == 0) {
                setTimeout(() => {
                  self.$store
                    .dispatch(path, serverData)
                    .then((res) => {
                      self.tabulator.updateData([data]);
                    })
                    .catch((err) => {
                      console.log("catch inside", err);
                    });
                }, 500);
              }
              self.tabulator.updateData([data]);
              api
                .get(`/portfolio/investments/${serverData._id}`)
                .then((data) => {
                  let investmentData = data.data.encrypt.success;
                  if (investmentData.length > 0) {
                    let investData =
                      response.success.length > 0
                        ? response.success[0]
                        : response.fail[0];
                    let investServerData = {};
                    investServerData.portfolio_item = investData._id;
                    investServerData.date = serverData.initial_investment;
                    api
                      .patch(`/date/${investmentData[0]._id}`, {
                        encrypt: { data: investServerData },
                      })
                      .then((res) => {})
                      .catch((err) => {
                        console.log("err", err);
                      });
                  } else {
                    let investData =
                      response.success.length > 0
                        ? response.success[0]
                        : response.fail[0];
                    let investServerData = {};
                    investServerData.portfolio_item = investData._id;
                    investServerData.transaction_date =
                      investData.initial_investment;
                    investServerData.offering =
                      investData.stage && investData.stage != "-"
                        ? investData.stage
                        : "Pre-Seed";
                    self.$store
                      .dispatch("investment/createInvestment", investServerData)
                      .then((res) => {})
                      .catch((err) => {
                        console.log("err", err);
                      });
                  }
                })
                .catch((err) => console.log(err));
              self.$store
                .dispatch("portfolio/_apiFetchPortfolio")
                .then((data) => {
                  self.isEditing = false;
                });
            });
          },
        },
        {
          title: "My Rating",
          field: "rating",
          formatter: "star",
          responsive: 0,
          resizable: false,
          minWidth: "101",
          download: true,
          formatterParams: { stars: 5 },
          editor: "star",
          editable: isEditable,
          cellEditing: function (cell) {
            //cell - cell component
            self.isEditing = true;
          },
          cellEdited: function (cell) {
            //cell - cell component
            let data = cell.getData();
            let serverData = {};
            serverData.rating = data.rating;
            serverData._id = data._id;
            serverData.__v = data.__v;
            let path = "company/apiPatchCompanyInst";
            self.$store.dispatch(path, serverData).then((response) => {
              if (response.success.length == 0) {
                setTimeout(() => {
                  self.$store
                    .dispatch(path, serverData)
                    .then((res) => {
                      self.tabulator.updateData([data]);
                    })
                    .catch((err) => {
                      console.log("catch inside", err);
                    });
                }, 500);
              }
              self.tabulator.updateData([data]);
              self.$store
                .dispatch("portfolio/_apiFetchPortfolio")
                .then((data) => {
                  self.isEditing = false;
                });
            });
          },
        },
        {
          title: "Multiple",
          field: "multiple",
          sorter: numberSorter,
          download: true,
          minWidth: "95",
          resizable: false,
          formatter: function (cell, params) {
            if (
              _.isNil(cell.getValue()) ||
              _.isNaN(cell.getValue()) ||
              (typeof cell.getValue() === "string" && cell.getValue() == "NaN")
            )
              return 0.0;
            return cell.getValue();
          },
        },
        {
          title: "Last Funding Round",
          field: "last_funding_round",
          minWidth: "158",
          sorter: function (a, b, aRow, bRow, column, dir, sorterParams) {
            let data;
            if (a != "-" && b != "-")
              data = new Date(a).getTime() - new Date(b).getTime();
            else if (a != "-") data = new Date(a).getTime();
            else data = -new Date(b).getTime();
            return data;
          },
          editor: dateEditor,
          resizable: false,
          download: true,
          editable: isEditable,
          // formatterParams: {
          //   outputFormat: "MM/DD/YYYY",
          //   invalidPlaceholder: "missing date"
          // },
          // formatter: function(cell, formatterParams) {
          //   let data = cell.getData();
          //   if (
          //     data.last_funding_round &&
          //     data.last_funding_round != "-" &&
          //     data.last_funding_round != "missing date"
          //   ) {
          //     return moment(data.last_funding_round).format("MM/DD/YYYY");
          //   } else {
          //     return "-";
          //   }
          // },
          cellEditing: function (cell) {
            //cell - cell component
            self.isEditing = true;
          },
          cellEdited: function (cell) {
            //cell - cell component
            let data = cell.getData();
            let serverData = {};
            serverData.last_funding_round = data.last_funding_round;
            serverData._id = data._id;
            serverData.__v = data.__v;
            let path = "company/apiPatchCompanyInst";
            self.$store.dispatch(path, serverData).then((response) => {
              if (response.success.length == 0) {
                setTimeout(() => {
                  self.$store
                    .dispatch(path, serverData)
                    .then((res) => {
                      self.tabulator.updateData([data]);
                    })
                    .catch((err) => {
                      console.log("catch inside", err);
                    });
                }, 500);
              }
              self.tabulator.updateData([data]);
              self.$store
                .dispatch("portfolio/_apiFetchPortfolio")
                .then((data) => {
                  self.isEditing = false;
                });
            });
          },
        },
        {
          title: "Current Stage",
          field: "stage",
          sorter: "string",
          resizable: false,
          editor: "select",
          minWidth: "129",
          download: true,
          editable: isEditable,
          editorParams: { values: stageSelect, defaultValue: "Pre-Seed" },
          cellEditing: function (cell) {
            //cell - cell component
            self.isEditing = true;
          },
          cellEdited: function (cell) {
            //cell - cell component
            let data = cell.getData();
            let serverData = {};
            serverData.stage = data.stage;
            serverData._id = data._id;
            serverData.__v = data.__v;
            let path = "company/apiPatchCompanyInst";
            self.$store.dispatch(path, serverData).then((response) => {
              if (response.success.length == 0) {
                setTimeout(() => {
                  self.$store
                    .dispatch(path, serverData)
                    .then((res) => {
                      self.tabulator.updateData([data]);
                    })
                    .catch((err) => {
                      console.log("catch inside", err);
                    });
                }, 500);
              }
              self.tabulator.updateData([data]);
              self.$store
                .dispatch("portfolio/_apiFetchPortfolio")
                .then((data) => {
                  self.isEditing = false;
                });
            });
          },
        },
        {
          title: "Geography",
          field: "geography",
          resizable: false,
          sorter: "string",
          download: true,
          minWidth: "110",
          editable: isEditable,
          editor: mapEditor,
          cellEditing: function (cell) {
            //cell - cell component
            self.isEditing = true;
          },
          cellEdited: function (cell) {
            //cell - cell component
            let data = cell.getData();
            let serverData = {};
            serverData.geography = data.geography;
            serverData._id = data._id;
            serverData.__v = data.__v;
            let path = "company/apiPatchCompanyInst";
            self.$store.dispatch(path, serverData).then((response) => {
              if (response.success.length == 0) {
                setTimeout(() => {
                  self.$store
                    .dispatch(path, serverData)
                    .then((res) => {
                      self.tabulator.updateData([data]);
                    })
                    .catch((err) => {
                      console.log("catch inside", err);
                    });
                }, 500);
              }
              self.tabulator.updateData([data]);
              self.$store
                .dispatch("portfolio/_apiFetchPortfolio")
                .then((data) => {
                  self.isEditing = false;
                });
            });
          },
        },
        {
          title: "Sector",
          field: "sector",
          sorter: "string",
          resizable: false,
          download: true,
          minWidth: "87",
          editor: "select",
          editable: isEditable,
          editorParams: { values: self.sortedSectors },
          cellEditing: function (cell) {
            //cell - cell component
            self.isEditing = true;
          },
          cellEdited: function (cell) {
            //cell - cell component
            let data = cell.getData();
            let serverData = {};
            serverData.sector = data.sector;
            serverData._id = data._id;
            serverData.__v = data.__v;
            let path = "company/apiPatchCompanyInst";
            self.$store.dispatch(path, serverData).then((response) => {
              if (response.success.length == 0) {
                setTimeout(() => {
                  self.$store
                    .dispatch(path, serverData)
                    .then((res) => {
                      self.tabulator.updateData([data]);
                    })
                    .catch((err) => {
                      console.log("catch inside", err);
                    });
                }, 500);
              }
              self.tabulator.updateData([data]);
              self.$store
                .dispatch("portfolio/_apiFetchPortfolio")
                .then((data) => {
                  self.isEditing = false;
                });
            });
          },
        },
        {
          title: "Status",
          field: "status",
          download: false,
          visible: false,
        },
        {
          title: "created",
          field: "created",
          sorter: "string",
          download: false,
          visible: false,
        },
        {
          title: "website",
          field: "website",
          sorter: "string",
          download: true,
          visible: false,
        },
        {
          title: "UCID",
          field: "ucid",
          resizable: false,
          sorter: "number",
          responsive: 3,
          visible: false,
        },
        {
          minWidth: 30,
          resizable: false,
          headerSort: false,
          responsive: 0,
          formatter: handleMenu,
          // contextMenu: [
          //   {
          //     label: "Send Email",
          //     action: function(e, cell) {
          //       self.tags = [];
          //       self.submit = false;
          //       self.modalShow = true;
          //       self.downloadCompany = cell.getData();
          //       // self.downloadPdf(cell.getData(), "Send Email");
          //     }
          //   },
          //   {
          //     label: "Download",
          //     action: function(e, cell) {
          //       self.downloadPdf(cell.getData(), "Download as Pdf");
          //     }
          //   }
          // ]
        },
        {
          // formatter: "responsiveCollapse",
          hozAlign: "center",
          resizable: false,
          responsive: 0,
          headerSort: false,
          formatter: function (cell, formatterParams, onRendered) {
            let self = this;
            if (that.hiddenColumnLength > 0) {
              var open = false,
                el = document.createElement("div");

              function toggleList(isOpen) {
                var collapse = cell
                  .getRow()
                  .getElement()
                  .getElementsByClassName("tabulator-responsive-collapse")[0];
                open = isOpen;

                if (open) {
                  el.classList.add("open");
                  if (collapse) {
                    collapse.style.display = "";
                  }
                } else {
                  el.classList.remove("open");
                  if (collapse) {
                    collapse.style.display = "none";
                  }
                }
              }

              el.classList.add("tabulator-responsive-collapse-toggle");
              el.innerHTML =
                "<span class='tabulator-responsive-collapse-toggle-open'>+</span><span class='tabulator-responsive-collapse-toggle-close'>-</span>";

              cell.getElement().classList.add("tabulator-row-handle");

              if (self.table.options.responsiveLayoutCollapseStartOpen) {
                open = true;
              }

              el.addEventListener("click", function () {
                self.currentUcid = cell._cell.row.data.ucid;
                toggleList(!open);
              });

              toggleList(open);

              return el;
            } else {
              return;
            }
          },
        },
      ];
    },
    isInlineEditable() {
      let rolePermissions = this.getCurrentWorkspaceRolePermissions;
      let index = rolePermissions.findIndex((item) => {
        if (item == "ADD INVESTMENT") {
          return item;
        }
      });
      return index >= 0 ? true : false;
    },
    showEditCompany() {
      let rolePermissions = this.getCurrentWorkspaceRolePermissions;
      let index = rolePermissions.findIndex((item) => {
        if (item == "EDIT COMPANY") {
          return item;
        }
      });
      return index >= 0 ? true : false;
    },
    showDeleteCompany() {
      let rolePermissions = this.getCurrentWorkspaceRolePermissions;
      if (
        this.data.user_investment_status &&
        this.data.user_investment_status != "Diligence"
      ) {
        let index = rolePermissions.findIndex((item) => {
          if (item == "DELETE PORTFOLIO") {
            return item;
          }
        });
        return index >= 0 ? true : false;
      } else {
        let index = rolePermissions.findIndex((item) => {
          if (item == "DELETE DILIGENCE") {
            return item;
          }
        });
        return index >= 0 ? true : false;
      }
    },
  },
  data() {
    return {
      modals: {
        custom: false,
        dataimport: false,
      },
      tabulator: null,
      isCSV: true,
      pagination: {
        perPage: 50,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50, 100],
        total: 0,
      },
      refreshForm: true,
      searchQuery: "",
      isEditing: false,
      tempData: null,
      emails: [],
      modalShow: false,
      dirty: false,
      submit: false,
      downloadCompany: {},
      tags: [],
      validTags: [],
      invalidTags: [],
      duplicateTags: [],
      dialogDataConfirmCompany: {
        isShow: false,
      },
      showEditModalPopup: false,
      editCompanyModalProps: {},
      tableLength: 0,
      addCompanyProps: {},
      showAddCompanyModal: false,
      refresh: true,
      sharingNote: "",
      contactEmailString: "",
      dialogMyInvestmentData: {
        isShow: false,
        data: {},
        isCreate: true,
      },
      investmentCompany: {},
      lastFundingRoundDate: "",
      portfolioAllRows: [],
      currentUcid: 0,
      hiddenColumnLength: 0,
      showFilter: false,
      filterValues: {
        cost: {},
        ownership: {},
        multiple: {},
      },
      filterJson: {},
      customFilterArray: [],
      isFilterApplied: false,
      searchFilter: [],
      addCompanyShow: false,
      addCompanySpinner: false,
      companiesList: [],
      isNewCompany: false,
      selected: false,
      companyName: "",
      minMatchingChars: 1,
      addCompanyData: {},
      data: {},
      showDeleteModal: false,
      modalContext: { name: "deleteprompt" },
    };
  },
  watch: {
    searchQuery: _.debounce(function (newVal) {
      this.tabulator.clearFilter(true);
      const self = this;
      if (!self.isFilterApplied || self.searchQuery.length == 0) {
        this.tabulator.clearFilter(true);
      }
      let appliedFilters = self.customFilterArray;
      self.searchFilter = [
        { field: "name", type: "like", value: self.searchQuery },
        { field: "sector", type: "like", value: self.searchQuery },
        { field: "stage", type: "like", value: self.searchQuery },
        { field: "geography", type: "like", value: self.searchQuery },
        { field: "cost", type: "like", value: self.searchQuery },
        { field: "value", type: "like", value: self.searchQuery },
        { field: "ownership", type: "like", value: self.searchQuery },
        { field: "status", type: "like", value: self.searchQuery },
        {
          field: "initial_investment",
          type: "like",
          value: self.searchQuery,
        },
        {
          field: "last_funding_round",
          type: "like",
          value: self.searchQuery,
        },
        { field: "rating", type: "like", value: self.searchQuery },
        { field: "multiple", type: "like", value: self.searchQuery },
      ];
      if (appliedFilters.length == 0) {
        self.tabulator.setFilter([self.searchFilter]);
      } else {
        if (self.searchQuery && self.searchQuery.length > 0) {
          let tabulatorFilter = self.isFilterApplied
            ? [[self.searchFilter], ...appliedFilters]
            : [self.searchFilter];
          self.tabulator.setFilter(tabulatorFilter);
        } else {
          if (self.isFilterApplied) {
            self.tabulator.setFilter(appliedFilters);
          }
        }
      }
    }, 300),
    tags(newVal, oldVal) {
      this.dirty = true;
    },
    tableData: {
      handler: function (newData) {
        if (!this.isEditing && this.tabulator) {
          if (this.tableLength != this.portfolioData.length) {
            this.tabulator.updateData(newData);
            //this.tabulator.updateData(newData);
            this.tableLength = this.portfolioData.length;
          }
          // else
          // {
          //   this.tabulator.updateData(newData);
          // }

          // if (!this.tabulator.rowManager.displayRowsCount) {
          //   this.tabulator.replaceData(newData);
          // } else {
          //   // this.tabulator.updateData(newData);
          //   this.tabulator.replaceData(newData);
          // }
        } else {
          this.tempData = newData;
        }
      },
    },
    companyName: _.debounce(function (addr) {
      if (addr.length > 0) {
        this.getCompanies(addr);
      }
    }, 500),
  },
  methods: {
    init() {
      window.moment = moment;
      let self = this;
      self.$store.commit("todo/setCurrentComponent", "portfolio");
      self.tabulator = new Tabulator(self.$refs.table, {
        layout: "fitDataFill",
        index: "id",
        tooltips: true,
        layoutColumnsOnNewData: true,
        //adjustTableSize: true,
        virtualDom: false,
        height: "100%",
        responsiveLayout: "collapse",
        responsiveLayoutCollapseStartOpen: false,
        data: self.tableData,
        columns: self.tableColumns,
        initialSort: [{ column: "created", dir: "desc" }],
        pagination: "local",
        paginationSize: 100,
        paginationSizeSelector: true,
        placeholder: "No records to view",
        dataFiltered: function (filters, rows) {
          //filters - array of filters currently applied
          //rows - array of row components that pass the filters
        },
        downloadReady: function (fileContents, blob) {
          if (self.isCSV) return blob;
          else {
            let formData = new FormData();
            let payload = {};
            payload.emails = self.emails;
            payload.sharingNote = self.sharingNote;
            formData.append("file", blob, "CSV");
            formData.append(
              "encrypt",
              JSON.stringify({ encrypt: { data: payload } })
            );
            api
              .post("/send-portfolio-email", formData, {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              })
              .then((res) => {
                self.$emit("download-complete", {});
              })
              .catch((err) => {
                console.error(`Error during file upload: ${err}`);
              });
            return false;
          }
        },
        responsiveLayoutCollapseFormatter: function (data) {
          self.hiddenColumnLength = this.hiddenColumns.length;
          let divMain = document.createElement("div");
          let divTable = document.createElement("div");
          divTable.className += "d-flex";
          data.forEach(function (col, index) {
            if (col.title != "UCID") {
              let item = document.createElement("div");
              if (index == 0) item.className += "mr-4";
              else if (index == data.length - 1) item.className += "ml-4";
              else item.className += "mx-4";
              item.innerHTML = `<div class="divHeaders">${col.title}</div><div>${col.value}</div>`;
              divTable.appendChild(item);
            }
          });
          divMain.appendChild(divTable);

          let divButtons = document.createElement("div");
          divButtons.className += "d-flex";
          divButtons.style.justifyContent = "flex-end";
          divButtons.style.paddingBottom = "20px";
          divButtons.style.paddingTop = "20px";
          divButtons.style.paddingRight = "14px";

          let updateButton = document.createElement("BUTTON");
          var updateTextButton = document.createTextNode("Update Details");
          updateButton.addEventListener("click", () => {
            //let rowClick = data.find(item => item.title == "UCID");
            let company = self.portfolioData.find(
              //item => item.ucid == rowClick.value
              (item) => item.ucid == self.currentUcid
            );
            self.handleEditCompany(company);
          });
          if (self.showEditCompany) {
            updateButton.className += "btn-fill btn-wd main-secondary-button";
            updateButton.appendChild(updateTextButton);
            divButtons.appendChild(updateButton);
          }
          let addInvestButton = document.createElement("BUTTON");
          var addInvestTextButton = document.createTextNode("Add Investment");
          addInvestButton.addEventListener("click", () => {
            // let rowClick = data.find(item => item.title == "UCID");
            let company = self.portfolioData.find(
              //item => item.ucid == rowClick.value
              (item) => item.ucid == self.currentUcid
            );
            self.handleAddInvestment(company);
          });
          if (self.isInlineEditable) {
            addInvestButton.className +=
              "ml-2 btn-fill btn-wd main-secondary-button";
            addInvestButton.appendChild(addInvestTextButton);
            divButtons.appendChild(addInvestButton);
          }
          // let button = document.createElement("BUTTON");
          // var textButton = document.createTextNode("View Details");
          // button.addEventListener("click", () => {
          //   // let rowClick = data.find(item => item.title == "UCID");
          //   let company = self.portfolioData.find(
          //     item => item.ucid == self.currentUcid
          //   );
          //   self.$store.commit("temp/currentCompany", company.ucid);
          //   self.$router.push(
          //     `/${self.$route.params.account_id}/${self.$route.params.workspace_id}/companyProfile/${company.ucid}`
          //   );
          // });
          // button.style.height = "39px";
          // button.className += "ml-2 m-0 todo-form-submit-button btn btn-primary";
          // button.appendChild(textButton);
          // divButtons.appendChild(button);

          divMain.appendChild(divButtons);
          return Object.keys(data).length ? divMain : "";
        },
        // footerElement:
        //   '<a href="#/portfolio/add"><i title="Add new company"  class="fa fa-plus-square fa-lg tabulator-footer" style="float: left;border-top: none;padding: 0;margin-top: 8px; color: #0097a7"></i></a>',
        cellEdited: function (cell) {
          // write the row and mark it as dirty\
          let row = _.reduce(
            cell._cell.row.cells,
            (m, c) => {
              if (c.column.field == "name" || c.column.field == cell.getField())
                m[c.column.field] = c.getValue();
              return m;
            },
            {}
          );
          self.$store.commit("portfolio/update", row);
          //self.$store.commit("company/update", { companies: row });
          // if (cell.getField() != "cost") {
          //   if (!_.isNil(self.tempData)) {
          //     self.tabulator.replaceData(self.tempData);
          //     self.tempData = null;
          //   }
          //   self.isEditing = false;
          // }
        },
        cellEditing: function (cell) {
          // need to prevent any updated data while this is true
          self.isEditing = true;
        },
        rowClick: function (e, row) {
          if (row.getData().data_status == DATA_STATUS_UNCONFIRMED) {
            self.openConfirmCompany(row.getData());

            e.preventDefault();
            return false;
          }
          if (row.getData().data_status == "NoCompanyUrl") {
            self.openAddCompanyModal(row.getData());
            e.preventDefault();
            return false;
          }
        },
        downloadDataFormatter: function (data) {
          data.data.forEach((element) => {
            if (
              element.initial_investment &&
              element.initial_investment != "-" &&
              element.initial_investment != "Invalid Date"
            ) {
              element.initial_investment = moment(
                element.initial_investment
              ).format("MM/DD/YYYY");
            } else {
              element.initial_investment = "-";
            }
            if (
              element.last_funding_round &&
              element.last_funding_round != "-" &&
              element.last_funding_round != "Invalid Date"
            ) {
              element.last_funding_round = moment(
                element.last_funding_round
              ).format("MM/DD/YYYY");
            } else {
              element.last_funding_round = "-";
            }
          });
          return data;
        },
        rowFormatter: function (row) {
          if (row.getData().data_status == DATA_STATUS_UPDATING) {
            row.getElement().classList.add("gray-row");
          } else {
            row.getElement().classList.remove("gray-row");
          }
        },
        rowMouseOver: function (e, row) {
          //e - the event object
          //row - row component
          self.currentUcid = row._row.data.ucid;
        },
      });

      this.checkDataStatus();
      // this.invervalHandle = setInterval(() => {
      //   this.checkDataStatus();
      // }, 5000);
      this.$store.dispatch("portfolio/_apiFetchPortfolio").then((data) => {
        if (this.tabulator) {
          let data = this.$store.getters["portfolio/portfolioData"];
          if (this.$route.query.new) {
            this.checkDataStatus();
            this.tabulator.replaceData(data);
            this.$router.push(
              `/${this.$route.params.account_id}/${this.$route.params.workspace_id}/portfolio`
            );
          }
        }
      });
      if (this.$route.query.f) {
        self.tabulator.setSort("data_status");
      }
    },
    checkDataLoaded() {
      let self = this;
      if (self.dataLoaded) {
        let data = this.$store.getters["portfolio/hasData"];
        if (!data) {
          // go to importer
          this.openModal("dataimport");
        }
        self.init();
        return;
      }

      setTimeout(() => {
        self.checkDataLoaded();
      }, 1000);
    },
    getMinMaxCostValue(myArray = this.getTableData()) {
      var lowest = 0;
      var highest = 0;
      var step = 0;
      var tmp;
      for (var i = myArray.length - 1; i >= 0; i--) {
        tmp = Math.ceil(myArray[i].cost);
        if (tmp < lowest) lowest = tmp;
        if (tmp > highest) highest = tmp;
      }
      var middle = (highest + lowest) / 2;
      if (highest > 300) step = Math.round(Math.ceil(highest) / 30);
      else step = 5;
      this.filterValues.cost = {
        lowest: Math.floor(lowest),
        highest: Math.ceil(highest),
        middle,
        step,
      };
    },
    getMinMaxOwnershipValue(myArray = this.getTableData()) {
      var lowest = 0;
      var highest = 0;
      var tmp;
      for (var i = myArray.length - 1; i >= 0; i--) {
        tmp = Math.ceil(myArray[i].ownership);
        if (tmp < lowest) lowest = tmp;
        if (tmp > highest) highest = tmp;
      }
      var middle = (highest + lowest) / 2;
      this.filterValues.ownership = {
        lowest: Math.floor(lowest),
        highest: Math.ceil(highest),
        middle,
      };
    },
    getMinMaxMultipleValue(myArray = this.getTableData()) {
      var lowest = 0;
      var highest = 0;
      var tmp;
      for (var i = myArray.length - 1; i >= 0; i--) {
        tmp = Math.ceil(myArray[i].multiple);
        if (tmp < lowest) lowest = tmp;
        if (tmp > highest) highest = tmp;
      }
      var middle = (highest + lowest) / 2;
      this.filterValues.multiple = {
        lowest: Math.floor(lowest),
        highest: Math.ceil(highest),
        middle,
      };
    },
    onTagState(valid, invalid, duplicate) {
      this.validTags = valid;
      this.invalidTags = invalid;
      this.duplicateTags = duplicate;
    },
    handleEditCompany(data) {
      let self = this;
      let payload = {
        diligenceId: "",
        portfolioItem: data._id,
      };
      api
        .post(`/portfolio/referrers`, { encrypt: { data: payload } })
        .then((resp) => {
          //  this.referralsData = data.data.encrypt.success[0];
          let propsData = JSON.parse(JSON.stringify(data));
          propsData.initial_investment =
            propsData.initial_investment && propsData.initial_investment != "-"
              ? propsData.initial_investment
              : "";
          propsData.name =
            propsData.name && propsData.name != "-" ? propsData.name : "";
          propsData.logo_url =
            propsData.logo_url && propsData.logo_url != "-"
              ? propsData.logo_url
              : "";
          propsData.category_data =
            propsData.category_data && propsData.category_data != "-"
              ? Array.from(
                  new Set(propsData.category_data.split(","))
                ).toString()
              : "";
          propsData.sector =
            propsData.sector && propsData.sector != "-" ? propsData.sector : "";
          propsData.founding_date =
            propsData.founding_date &&
            propsData.founding_date != "-" &&
            propsData.founding_date != "Invalid date"
              ? propsData.founding_date
              : "";
          propsData.stage_i_invested =
            propsData.stage_i_invested && propsData.stage_i_invested != "-"
              ? propsData.stage_i_invested
              : "";
          propsData.company_type =
            propsData.company_type && propsData.company_type != "-"
              ? propsData.company_type
              : "";
          propsData.last_funding_round =
            propsData.last_funding_round && propsData.last_funding_round != "-"
              ? propsData.last_funding_round
              : "";
          if (propsData.last_funding_round == "-") {
            propsData.last_funding_round = "";
          }
          propsData.geography =
            propsData.geography && propsData.geography != "-"
              ? propsData.geography
              : "";
          propsData.employee_count =
            propsData.employee_count && propsData.employee_count != "-"
              ? propsData.employee_count
              : "";
          propsData.website =
            propsData.website && propsData.website != "-"
              ? propsData.website
              : "";
          propsData.contact_email =
            propsData.contact_email && propsData.contact_email != "-"
              ? propsData.contact_email
              : "";
          propsData.facebook =
            propsData.facebook && propsData.facebook != "-"
              ? propsData.facebook
              : "";
          propsData.linkedin =
            propsData.linkedin && propsData.linkedin != "-"
              ? propsData.linkedin
              : "";
          propsData.twitter =
            propsData.twitter && propsData.twitter != "-"
              ? propsData.twitter
              : "";
          propsData.description =
            propsData.description && propsData.description != "-"
              ? propsData.description
              : "";
          propsData.referred_by = resp.data.encrypt.success[0];
          self.editCompanyModalProps = {
            isShow: true,
            data: propsData,
          };
          self.showEditModalPopup = true;
        })
        .catch((err) => console.log(err));
    },
    tagValidator(tag) {
      let value = tag.length > 5 && tag.includes("@") && tag.includes(".");
      return value;
    },
    download() {
      let currentTime = new Date().toLocaleString().split(", ").join("_");
      let fileName = `${this.user.firstName}_${this.user.lastName}_${currentTime}`;
      this.tabulator.download("csv", `${fileName}.csv`);
      //this.$toaster.success("Download Completed");
    },
    sendEmail() {
      let self = this;
      this.submit = true;
      // this.downloadPdf(this.downloadCompany, "Send Email");
      this.SharingCompanySubmit = true;
      let serverData = {};
      serverData.emails = this.tags;
      serverData.note = this.sharingNote;
      serverData.permalink = this.downloadCompany.permalink;
      serverData.component = "Portfolio link from profile";
      serverData.account = this.$route.params.account_id;
      serverData.company = this.downloadCompany.name;
      serverData.organization = this.downloadCompany.organization;
      let userName = self.$store.getters["user/user"];
      let userNameString =
        userName.firstName != userName.lastName
          ? `${userName.firstName} ${userName.lastName} `
          : userName.lastName;
      serverData.senderName = userNameString;
      fetch(`${config.API_URL}/sharePortfolio`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          data: serverData,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          self.sentDealMethod(serverData);
        })
        .catch((error) => {
          console.log("share portfolio error", error);
          this.tags = [];
          this.modalShow = false;
          this.$toaster.error(
            "Unable to process your request, please try again"
          );
          this.submit = false;
        });
    },
    sentDealMethod(payload) {
      let self = this;
      if (payload.emails && payload.emails.length > 0) {
        let sentDealPayload = {
          name: payload.company ? payload.company : "",
          permalink: payload.permalink ? payload.permalink : "",
          logo: self.downloadCompany.logo_url
            ? self.downloadCompany.logo_url
            : "",
          sector: self.downloadCompany.sector
            ? self.downloadCompany.sector
            : "",
          note: payload.note ? payload.note : "",
          organization: self.downloadCompany.organization,
          emails: payload.emails,
          sent_by: self.$route.params.account_id,
        };
        self.$store
          .dispatch("referrer/apiPostSentDeal", sentDealPayload)
          .then((data) => {
            self.tags = [];
            self.modalShow = false;
            self.$toaster.success("Email will be sent shortly.");
            self.submit = false;
            self.downloadCompany = {};
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    downloadPdf(company, type) {
      //this.$notify({ component: NotificationSample, timeout: 30000 });
      let portfolioDetails = company;
      portfolioDetails.initial_investment =
        company.initial_investment && company.initial_investment.length > 7
          ? moment.utc(company.initial_investment).format("MM/DD/YYYY")
          : "-";
      portfolioDetails.last_funding_round =
        company.last_funding_round && company.last_funding_round.length > 7
          ? moment.utc(company.last_funding_round).format("MM/DD/YYYY")
          : "-";
      portfolioDetails.founding_date =
        portfolioDetails.founding_date &&
        portfolioDetails.founding_date != "Invalid date"
          ? portfolioDetails.founding_date
          : "-";
      if (portfolioDetails.founding_date == "Invalid date") {
        portfolioDetails.founding_date = "-";
      }
      let companyNamePdf = company.name.split(" ").join("_");
      let currentTime = new Date().toLocaleString().split(", ").join("_");
      let fileName = `${companyNamePdf}_${currentTime}.pdf`;
      const payload = {
        portfolio: {
          portfolioOwnership: company.ownership ? company.ownership : "-",
          portfolioCost: company.cost ? company.cost : "-",
          portfolioValue: company.value ? company.value : "-",
          portfolioMultiple: company.multiple ? company.multiple : "-",
          portfolioGain: company.gain_loss ? company.gain_loss : "-",
          contact_email: company.contact_email ? company.contact_email : "-",
          companyContacts: company.conatcts ? company.conatcts : "-",
        },
        pdfType: type,
        recieverEmail: this.tags ? this.tags.toString() : "",
        currentCompany: company,
        fileName: `${companyNamePdf}_${currentTime}.pdf`,
        notes: company.notes,
        portfolioDetails,
      };
      if (type != "Send Email")
        this.$toaster.success("Download In-progress...");
      else {
        payload.sharingNote = this.sharingNote;
      }
      api
        .post(`/send/download/pdf`, { encrypt: { data: payload } })
        .then((res) => {
          this.$notifyClear();
          if (type != "Send Email") {
            this.$toaster.success("Downloaded Successfully");
            return window.open(res.data.encrypt.success);
          } else {
            this.tags = [];
            this.modalShow = false;
            this.$toaster.success("Email will be sent shortly.");
            this.submit = false;
          }
        })
        .catch((err) => {
          console.log({ err });
          this.$toaster.error("Fail to process your request.Please try again.");
        });
    },
    openModal(name) {
      this.modals[name] = true;
    },
    closeModal(name) {
      this.modals[name] = false;
    },
    computeGainLoss(data) {
      data.value = !isNaN(data.value) ? data.value : 0;
      data.cost = !isNaN(data.cost) ? data.cost : 0;
      return typeof data.value == "number" && typeof data.cost == "number"
        ? data.value - data.cost
        : 0;
    },
    computeMultiple(data) {
      return data.value > 0 && data.cost > 0
        ? (data.value / data.cost).toFixed(2)
        : 0;
    },
    handleDelete(index, row) {
      let indexToDelete = this.tableData.findIndex(
        (tableRow) => tableRow.id === row.id
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },
    downloadSample(event) {
      this.$refs.hiddenDownloadAnchor.click();
    },
    openConfirmCompany(data) {
      this.dialogDataConfirmCompany = {
        isShow: true,
        data: data,
      };
    },
    checkDataStatus() {
      let check = false;
      for (let i = 0; i < this.portfolioData.length; i++) {
        if (this.portfolioData[i]["data_status"] == DATA_STATUS_UPDATING) {
          check = true;
          break;
        }
      }
      if (check && !this.isEditing) {
        this.$store.commit("infobox/infoBoxVisibility", {
          show: true,
          displayText: `Sit tight. We're now populating the data from your companies.
            When enough data has been populated, click the company verify 
            it, after which you can view and edit that company.`,
        });

        // this.$store.dispatch("people/apiFetchPeople");
      }

      if (check) {
        window.sessionStorage.setItem("portfolioCheck", true);
        const self = this;
        let timeGap = 5000;
        let count = [];
        if (!window.sessionStorage.getItem("loopCheck")) {
          let timeInterval = setInterval(() => {
            window.sessionStorage.setItem("loopCheck", true);
            this.$store
              .dispatch("portfolio/_apiFetchPortfolio")
              .then((data) => {
                window.sessionStorage.setItem("loopCheck", true);
                let checkLength = 0;
                let checkCount = 0;
                let array = [];
                if (window.sessionStorage.getItem("portfolioCheck")) {
                  // for (var i = 0; i < data.length; i++) {
                  //   if (data[i]["data_status"] == DATA_STATUS_UPDATING) {
                  //     checkLength = 1;
                  //     checkCount++;
                  //   }
                  // }
                  array = data.filter((item) => {
                    if (item.data_status == DATA_STATUS_UPDATING) {
                      checkCount++;
                      return item;
                    }
                  });
                  if (array.length > 0) {
                    checkLength = 1;
                  }
                  count.push(checkCount);
                  if (checkLength == 0) {
                    count = [];
                    if (window.sessionStorage.getItem("loopCheck")) {
                      window.sessionStorage.removeItem("loopCheck");
                    }
                    if (self.tabulator) {
                      let responseData =
                        self.$store.getters["portfolio/portfolioData"];
                      self.tabulator.updateData(responseData).then(() => {});
                    }
                    clearInterval(timeInterval);
                  } else {
                    if (count.length > 1) {
                      if (count[count.length - 1] != count[count.length - 2]) {
                        if (this.tabulator) {
                          let responseData =
                            self.$store.getters["portfolio/portfolioData"];
                          self.tabulator
                            .updateData(responseData)
                            .then(() => {});
                        }
                      }
                    }
                  }
                } else {
                  clearInterval(timeInterval);
                }
              })
              .catch((err) => {
                clearInterval(timeInterval);
              });
          }, timeGap);
        }
      }
      // this.$store.dispatch("portfolio/_apiFetchPortfolio").then(data => {
      //   if (this.tabulator) {
      //     let data = this.$store.getters["portfolio/portfolioData"];
      //     if (this.$route.query.new) {
      //       this.tabulator.replaceData(data);
      //       this.$router.push(
      //         `/${this.$route.params.account_id}/${this.$route.params.workspace_id}/portfolio`
      //       );
      //     }
      //   }
      // });
    },
    handleCreateCompany() {
      this.addCompanyProps = {
        isShow: true,
        data: {},
      };
      this.showAddCompanyModal = true;
    },
    customFilter(data, filterParams) {
      setTimeout(() => {
        return (
          data.name.includes(this.searchQuery) ||
          data.status.includes(this.searchQuery) ||
          data.stage.includes(this.searchQuery) ||
          data.sector.includes(this.searchQuery) ||
          data.geography.includes(this.searchQuery)
        );
      }, 200);
    },
    handleAddInvestment(company) {
      this.investmentCompany = company;
      this.contactEmailString =
        company.contact_email != "-" && company.contact_email != ""
          ? company.contact_email
          : "";
      this.dialogMyInvestmentData = {
        isShow: true,
        isCreate: true,
        data: {
          company_name: company.name,
          portfolio_item: company._id,
          workspace: company.workspace,
          investment_type: "Unknown",
          transaction_date: new Date(),
          currentValue: company.value,
        },
        portfolio_item: company._id,
      };
    },
    getTableData() {
      const self = this;
      return _.map(this.portfolioData, (data, index) => {
        data["status"] = data["status"] ? data["status"] : "Unknown";
        data["multiple"] = this.computeMultiple(data);
        data["gain_loss"] = this.computeGainLoss(data);
        data["cost"] = data.cost ? Number(data["cost"]) : 0;
        data["ownership"] = data.ownership ? Number(data.ownership) : 0;
        data["rating"] = !_.isNil(data.rating) ? data.rating : 0;
        data["nameStatus"] = `${data.name} - ${data.status}`;
        data.geography =
          data.geography && data.geography != "Unspecified"
            ? data.geography
            : "";
        data.sector =
          data.sector && data.sector != "Unknown" ? data.sector : "-";
        data.logo_url = data.logo_url
          ? data.logo_url
          : "static/img/generic-logo.png";
        if (
          data.initial_investment &&
          data.initial_investment != "-" &&
          data.initial_investment != "missing date"
        ) {
          data.initial_investment = moment(data.initial_investment).format(
            "MM/DD/YYYY"
          );
        } else {
          data.initial_investment = "-";
        }
        if (
          data.last_funding_round &&
          data.last_funding_round != "-" &&
          data.last_funding_round != "missing date"
        ) {
          data.last_funding_round = moment(data.last_funding_round).format(
            "MM/DD/YYYY"
          );
        } else {
          data.last_funding_round = "-";
        }
        data.id = index;
        let logoUrl =
          data.hasOwnProperty("image_id") && data.image_id.length > 0
            ? `${config.CRUNCHBASE_IMAGE_URL}/${data.image_id}`
            : data.logo_url;
        if (data.data_status == DATA_STATUS_CONFIRMED) {
          data.nameLogoString = `
                <div class="d-flex">
                    <img src="${self.getImageUrl(
                      logoUrl
                    )}" style="width: 35px;height: 35px;border-radius: 50%;" class="company-img"/>
                    <img src="static/img/confirmed.svg" class="company-statys-img"/>
                            <b style="margin-left: 48px;overflow:hidden;whitespace:nowrap;text-overflow:ellipsis;">${
                              data.name
                            }  </b> <a style="color: #00000080;overflow:hidden;whitespace:nowrap;text-overflow:ellipsis;">-${
            data.status
          }</a>
                </div>

            `;
        }
        if (data.data_status == DATA_STATUS_UNCONFIRMED) {
          data.nameLogoString = `
                <div class="d-flex">
                    <img src="${self.getImageUrl(
                      logoUrl
                    )}" style="width: 35px;height: 35px;border-radius: 50%;" class="company-img"/>
                    <img src="static/img/warning.svg" class="company-statys-img"/>
                            <b class="ml-5" style="overflow:hidden;whitespace:nowrap;text-overflow:ellipsis;">${
                              data.name
                            } </b> <a style="color: #00000080;overflow:hidden;whitespace:nowrap;text-overflow:ellipsis;">-${
            data.status
          }</a>
                </div>
            `;
        }
        if (data.data_status == DATA_STATUS_UPDATING) {
          data.nameLogoString = `
                <div class="d-flex">
                    <img src="${self.getImageUrl(
                      logoUrl
                    )}" style="width: 35px;height: 35px;border-radius: 50%;" class="company-img"/>
                    <img src="static/img/retrieving.svg" class="company-statys-img"/>
                            <b class="ml-5" style="overflow:hidden;whitespace:nowrap;text-overflow:ellipsis;">${
                              data.name
                            } </b> <a style="color: #00000080;overflow:hidden;whitespace:nowrap;text-overflow:ellipsis;">-${
            data.status
          }</a>
                </div>
            `;
        }
        if (data.data_status == "NoCompanyUrl") {
          data.nameLogoString = `
                <div class="d-flex">
                    <img src="${self.getImageUrl(
                      logoUrl
                    )}" style="width: 35px;height: 35px;border-radius: 50%;" class="company-img"/>
                    <img src="static/img/warning.svg" class="company-statys-img"/>
                            <b class="ml-5" style="overflow:hidden;whitespace:nowrap;text-overflow:ellipsis;">${
                              data.name
                            } </b> <a style="color: #00000080;overflow:hidden;whitespace:nowrap;text-overflow:ellipsis;">-${
            data.status
          }</a>
                </div>
            `;
        }
        return data;
      });
    },
    getImageUrl(image) {
      if (!image) {
        return;
      }
      // image.includes(
      //  "https://res-3.cloudinary.com/crunchbase-production/image/upload"
      //) ||
      if (
        image.includes(config.CRUNCHBASE_IMAGE_URL) ||
        image.includes("https://res") ||
        image.includes("static/img/generic-logo.png")
      ) {
        return image;
      }
      let imageId = image.slice(image.lastIndexOf("t_api_images/") + 13);
      if (!imageId || imageId.length == 0) {
        return image;
      }
      return `${config.CRUNCHBASE_IMAGE_URL}/${imageId}`;
    },
    handleAddCompanyCancel() {
      this.addCompanyShow = false;
      this.addCompanySpinner = false;
      this.companyName = "";
      if (this.$refs.refCompanyName) {
        this.$refs.refCompanyName.inputValue = "";
      }
      this.addCompanyData = {};
      this.selected = false;
    },
    async getCompanies(query) {
      this.isNewCompany = false;
      this.selected = false;

      let responseData = await api.get(`search?key=${query}`);

      const suggestions = cbAdapter(responseData);

      if (suggestions.data.items && suggestions.data.items.length > 0)
        this.companiesList = suggestions.data.items;
      else {
        this.companiesList = [
          {
            properties: {
              name: this.companyName,
              short_description: "No results Found. Continue..",
            },
          },
        ];
      }
    },
    checkCompany(item) {
      let companies = this.portfolioAll;
      let check;
      if (item.properties.permalink) {
        if (companies && companies.length > 0) {
          check = companies.filter(
            (company) =>
              item.properties.permalink &&
              company.permalink == item.properties.permalink
          );
        }
      } else {
        if (companies && companies.length > 0) {
          check = companies.filter(
            (company) =>
              item.properties.name && company.name == item.properties.name
          );
        }
        if (check && check.length > 0)
          item.properties.short_description = "Company already exists";
      }
      if (check && check.length > 0) item.duplicate = "found";
      return item.properties.name;
    },
    onAfterCompanySelection(selectedValue) {
      let self = this;
      self.selected = true;
      self.companyName = "";
      if (
        selectedValue.properties.short_description ==
        "No results Found. Continue.."
      )
        self.isNewCompany = true;

      self.addCompanyData.name = selectedValue.properties.name;
      self.addCompanyData.geography = selectedValue.properties.city_name;
      self.addCompanyData.website = selectedValue.properties.homepage_url;
      self.addCompanyData.facebook = selectedValue.properties.facebook_url;
      self.addCompanyData.linkedin = selectedValue.properties.linkedin_url;
      self.addCompanyData.twitter = selectedValue.properties.twitter_url;
      self.addCompanyData.logo_url = selectedValue.properties.profile_image_url;
      self.addCompanyData.permalink = selectedValue.properties.permalink;
      self.addCompanyData.cb_data = selectedValue;
    },
    openAddCompanyModal(data) {
      const self = this;
      self.addCompanyData = data;
      self.companyName = "";
      self.addCompanyShow = true;
      document.getElementsByClassName("diligenceAutoCompleteClass");
      setTimeout(() => {
        self.$refs.refCompanyName.inputValue =
          data && data.name ? data.name : "";
        self.$refs.refCompanyName.isFocused = true;
      }, 300);

      self.companyName = data.name;
    },
    companySave() {
      const self = this;
      self.addCompanySpinner = true;

      if (
        this.addCompanyData &&
        this.addCompanyData.cb_data &&
        this.addCompanyData.cb_data.properties &&
        this.addCompanyData.cb_data.properties.short_description &&
        this.addCompanyData.cb_data.properties.short_description ==
          "No results Found. Continue.."
      ) {
        this.addCompanyData.data_status = DATA_STATUS_CONFIRMED;
        return api
          .patch(`/${this.addCompanyData._id}/portfolioConfirmCompany`, {
            companyName: self.addCompanyData.name,
          })
          .then((res) => {
            this.$store
              .dispatch("portfolio/_apiFetchPortfolio")
              .then((data) => {
                if (this.tabulator) {
                  let data = this.$store.getters["portfolio/portfolioData"];
                  this.tabulator.updateData(data);
                  this.checkDataStatus();
                  this.$toaster.success("Saved Successfully");
                  this.handleAddCompanyCancel();
                }
              });
          })
          .catch((e) => {
            console.error("error: ", e);
            this.$toaster.error("Failed to save!!!");
            this.handleAddCompanyCancel();
          });
      }
      let url = `${this.$route.params.account_id}/${this.$route.params.workspace_id}/company/confirm`;
      api
        .post(url, {
          encrypt: {
            data: {
              company: this.addCompanyData,
              confirmedCompany: this.addCompanyData.cb_data,
            },
          },
        })
        .then((res) => {
          this.$store.dispatch("portfolio/_apiFetchPortfolio").then((data) => {
            if (this.tabulator) {
              let data = this.$store.getters["portfolio/portfolioData"];
              this.tabulator.updateData(data);
              this.checkDataStatus();
              this.$toaster.success("Saved Successfully");
              this.handleAddCompanyCancel();
            }
          });
        })
        .catch((e) => {
          console.error("error: ", e);
          this.$toaster.error("Failed to save!!!");
          this.handleAddCompanyCancel();
        });
    },
    deleteCompany() {
      const self = this;
      // need to delete 3 things
      // 1 portfolio data associated with company
      // 2 people associated with company
      // 3 attachments/docs associated with the company
      // 4 company itself

      // assume successful delete, next people...
      let dilignceItem;
      if (!self.data.diligenceId) {
        let diligenceData = this.$store.getters["diligence/diligenceData"];
        dilignceItem = diligenceData.find(
          (item) => item.portfolio_item == self.data._id
        );
      }
      api
        .delete(
          `${self.$route.params.account_id}/${self.$route.params.workspace_id}/company/investment/${self.data.ucid}`
        )
        .then((data) => {})
        .catch((err) => {
          console.log(err);
        });
      return self.$store
        .dispatch("people/removeCompany", {
          ucid: self.data.ucid,
        })
        .then((res) => {
          if (self.data.diligenceId || (dilignceItem && dilignceItem._id)) {
            return self.$store.dispatch("diligence/apiDeleteDiligence", {
              ucid: self.data.ucid,
              _id:
                self.data && self.data.diligenceId
                  ? self.data.diligenceId
                  : dilignceItem._id,
            });
          } else return;
        })
        .then((res) => {
          // delete all attachments
          // delete all investments
          return self.$store.dispatch("investment/removeCompany", {
            ucid: self.data.ucid,
          });
        })
        .then((res) => {
          // delete all attachments
          return self.$store.dispatch("attachment/removeCompany", {
            ucid: self.data.ucid,
          });
        })
        .then((res) => {
          // delete all attachments
          return self.$store.dispatch("file/removeCompany", {
            ucid: self.data.ucid,
          });
        })
        .then((res) => {
          // assume successful delete, finally company...
          return self.$store.dispatch("portfolio/apiDeletePortfolio", {
            ucid: self.data.ucid,
            _id: self.data._id,
          });
        })
        .then((res) => {
          return self.$store.dispatch("offering/apiDeletePortfolioOfferings", {
            ucid: self.data.ucid,
          });
        })
        .then((res) => {
          let payload = {};
          if (self.data.user_investment_status == "Diligence") {
            payload.diligence_id =
              self.data && self.data.diligenceId
                ? self.data.diligenceId
                : dilignceItem._id;
          } else {
            payload.portfolio_item = self.data._id;
          }
          return self.$store.dispatch("portfolio/apiDeleteReferrers", payload);
        })
        .then((res) => {
          self.$store.dispatch("portfolio/_apiFetchPortfolio");
        })
        .then((res) => {
          return self.$store.dispatch("referrer/start");
        })
        .then((res) => {
          return self.$store.dispatch("contacts/start");
        })
        .then((res) => {
          // done, company should be erased, go back
          //self.modals[DELETEPROMPT] = false;
          //self.updateDisplay++;
          self.showDeleteModal = false;
          if (self.data.diligenceId || (dilignceItem && dilignceItem._id)) {
            this.$store
              .dispatch("diligence/apiCleanFetchDiligence")
              .then((data) => {
                if (self.data.diligenceId) {
                  window.sessionStorage.setItem(
                    "diligence_id",
                    self.data.diligenceId
                  );
                } else if (dilignceItem && dilignceItem._id) {
                  window.sessionStorage.setItem(
                    "diligence_id",
                    dilignceItem._id
                  );
                }
                self.$store
                  .dispatch("portfolio/_apiFetchPortfolio")
                  .then((data) => {
                    if (self.tabulator) {
                      let data = this.$store.getters["portfolio/portfolioData"];
                      self.tabulator.replaceData(data);
                      self.$toaster.success("Deleted Successfully");
                      if (self.$refs.confirmDeleteCard) {
                        self.$refs.confirmDeleteCard.isDeleting = false;
                      }
                      self.showDeleteModal = false;
                    }
                  });
              });
          } else {
            self.$store
              .dispatch("portfolio/_apiFetchPortfolio")
              .then((data) => {
                if (self.tabulator) {
                  let data = this.$store.getters["portfolio/portfolioData"];
                  self.tabulator.replaceData(data);
                  self.$toaster.success("Deleted Successfully");
                  if (self.$refs.confirmDeleteCard) {
                    self.$refs.confirmDeleteCard.isDeleting = false;
                  }
                  self.showDeleteModal = false;
                }
              });
          }
        })
        .catch((err) => {
          console.error(`Error during delete process, aborting... ${err}`);
          // go back to investments
          //self.modals[DELETEPROMPT] = false;
          self.updateDisplay++;
          if (self.data.diligenceId || dilignceItem) {
            this.$store
              .dispatch("diligence/apiCleanFetchDiligence")
              .then((data) => {
                self.$store
                  .dispatch("portfolio/_apiFetchPortfolio")
                  .then((data) => {
                    if (self.tabulator) {
                      let data = this.$store.getters["portfolio/portfolioData"];
                      self.tabulator.replaceData(data);
                      self.$toaster.success("Deleted Successfully");
                      if (self.$refs.confirmDeleteCard) {
                        self.$refs.confirmDeleteCard.isDeleting = false;
                      }
                      self.showDeleteModal = false;
                    }
                  });
              });
          } else {
            self.$store
              .dispatch("portfolio/_apiFetchPortfolio")
              .then((data) => {
                if (self.tabulator) {
                  let data = this.$store.getters["portfolio/portfolioData"];
                  self.tabulator.replaceData(data);
                  self.$toaster.success("Deleted Successfully");
                  if (self.$refs.confirmDeleteCard) {
                    self.$refs.confirmDeleteCard.isDeleting = false;
                  }
                  self.showDeleteModal = false;
                }
              });
          }
        });
    },
    closeModal(ctx, eventData) {
      const self = this;
      if (!_.isNil(eventData) && eventData.confirm) {
        // delete the company and related data
        self.deleteCompany();
      } else {
        self.showDeleteModal = false;
      }
    },
  },
  created() {
    //this.$store.getters["todo/portfolioTodos"];
    // this.$store.getters["todo/componentTodos"](
    //   "portfolio",
    //   this.$route.params.workspace_id
    // );
  },
  mounted() {
    this.checkDataLoaded();
  },
  beforeDestroy() {
    this.$store.commit("infobox/infoBoxVisibility", {
      show: false,
      displayText: ``,
    });

    if (this.invervalHandle) {
      clearInterval(this.invervalHandle);
    }
  },
};
</script>
<style>
.direct-invst-table .tabulator-arrow {
  /* display: none !important; */
  margin-top: 10px !important;
}

.delete-a:hover,
.share-portfolio-a:hover {
  background-color: #f8f9fa;
}
.company-img {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 1;
}
.company-statys-img {
  position: absolute;
  top: 6px;
  left: 35px;
  z-index: 2;
}

/* .direct-invst-table .tabulator-row{
  height: 50px !important;
} */
</style>